import {config} from "../../../constants/config";

export default {
  listDropLetDO: [],
  listSizeDO : [],
  listImageDO : [],
  listSSHKeyDO : [],
  listTagDO : [],
  listBackupSearch :[] ,
  listSnapShotSearch :[] ,
  listKernelSearch :[] ,
  listFireWallSearch :[] ,
  listNeighBorSearch :[] ,
  listResourceSearch :[] ,
  totalDropLetDO : 1,
  currentPage : 1,
  per_page : 10
}



// WEBPACK FOOTER //
// ./src/store/digital-ocean/moduleDropLet/state.js